export default "__VITE_ASSET__CAJknVvj__"